import styled from 'styled-components';
import ContentLoader from 'react-content-loader';
import {
  SelectModal,
  TooltipNewIcon,
  TransparentButton,
} from '@libs/components';
import CurrencySwitcher from '../currency-switcher/CurrencySwitcher';
import Bullets from '../bullets/Bullets';
type FooterProps = {
  footerBorderRadius?: boolean;
};
export const Wrapper = styled.div`
  padding: 0;
  background: unset;
  border-radius: unset;
  width: 100%;
  overflow: hidden;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin-bottom: 0;
  ${({ theme }) => theme.media.laptop`
    background: linear-gradient(108.82deg, #3067db 0%, #52a2ff 100%);
    padding: 0.8rem;
    border-radius: ${theme.borderRadius.x8 as unknown as TemplateStringsArray};
     margin-bottom: 2.4rem;
    width: 100%;
  `};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  overflow: hidden;
  background: linear-gradient(180deg, #f4f9ff 0%, #ebf4ff 100%);
  padding-top: 8.2rem;
  ${({ theme }) => theme.media.laptop`
  padding-top:0;
  border-radius: ${theme.borderRadius.x7 as unknown as TemplateStringsArray};
    background: ${
      theme.colors.surface.default as unknown as TemplateStringsArray
    };
  `};
`;
export const Body = styled.div`
  width: 100%;
  background: linear-gradient(180deg, #f4f9ff 0%, #ebf4ff 100%);
  ${({ theme }) => theme.media.laptop`
    background: ${
      theme.colors.surface.default as unknown as TemplateStringsArray
    };
  `};
`;
export const Footer = styled.div<FooterProps>`
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  background-color: ${({ theme }) => theme.colors.surface.default};
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  border-bottom-left-radius: ${({ footerBorderRadius, theme }) =>
    !footerBorderRadius ? theme.borderRadius.x4 : 0};
  border-bottom-right-radius: ${({ footerBorderRadius, theme }) =>
    !footerBorderRadius ? theme.borderRadius.x4 : 0};
  border-top: unset;

  box-shadow: ${({ theme }) => theme.shadows.white_upper};
  ${({ theme }) => theme.media.laptop`
        border-top: 0.5px solid ${
          theme.colors.borders.default as unknown as TemplateStringsArray
        };
        border-radius:${
          theme.borderRadius.x4 as unknown as TemplateStringsArray
        };
        border-top-left-radius:0;
        border-top-right-radius:0;

        box-shadow: unset;

  `};
`;
export const BodyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2.4rem 1.6rem 0;

  ${({ theme }) => theme.media.laptop`
      margin: 2.4rem 2.8rem 0;
  `};
`;
export const CustomCurrencySwitcher = styled(CurrencySwitcher)`
  max-width: 16.5rem;
  width: 16.5rem;

  border-radius: ${({ theme }) => theme.borderRadius.x8};
  .activeCurrencyUnderline {
    border-radius: ${({ theme }) => theme.borderRadius.x8};
  }
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
  border: 0.5px solid ${({ theme }) => theme.colors.borders.default};
  ${({ theme }) => theme.media.laptop`
    align-self: baseline;
    max-width: 14rem;
    width: 14rem;
    border-radius: ${theme.borderRadius.x8 as unknown as TemplateStringsArray};
    margin-top:unset;
    border:unset;
    .activeCurrencyUnderline {
      border-radius: ${
        theme.borderRadius.x8 as unknown as TemplateStringsArray
      };
      
  `};
`;
export const FlexCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.4rem 0 2.8rem;
`;
export const EyeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  min-height: 4.4rem;
`;
export const CustomBullets = styled(Bullets)`
  width: 1rem;
  height: 1rem;
`;

export const BalanceWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const NavigationItemIconWrapper = styled.div`
  min-width: 6rem;
  min-height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.surface.buttonBackground};
  border-radius: ${({ theme }) => theme.borderRadius.x14};
  border: 1px solid ${({ theme }) => theme.colors.interactive.secondaryHover};
  margin-bottom: 0.8rem;
`;
export const ItemWrapper = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  padding: 1.2rem 0 2rem;
  height: -webkit-fill-available;
  transition: all 0.3s ease;
  max-height: fit-content;
  &:hover {
    ${NavigationItemIconWrapper} {
      opacity: 0.5;
    }
  }
  ${({ theme }) => theme.media.laptop`
    &:hover {
    background-color: ${
      theme.colors.interactive.secondary as unknown as TemplateStringsArray
    };
    ${NavigationItemIconWrapper as unknown as TemplateStringsArray} {
      opacity: 1;

      border: 0.1rem solid ${
        theme.colors.interactive.brandColor as unknown as TemplateStringsArray
      };
      background-color: ${
        theme.colors.interactive.brandColor as unknown as TemplateStringsArray
      };
      .operationIcon {
        path {
          fill: ${
            theme.colors.text.interactive as unknown as TemplateStringsArray
          };
        }
      }
    }
  }
      padding: 2rem 0;`};
`;
export const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;
export const CustomSelect = styled(SelectModal)`
  width: unset;
  height: 2.8rem;
  margin-left: 0.8rem;
  padding: 0.4rem 0.8rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.surface.default};
  box-shadow: ${({ theme }) => theme.shadows.xs};
  .valueWrapper {
    white-space: nowrap;
  }
  .select-dropdown-icon {
    padding: 0 0.4rem;
  }
` as typeof SelectModal;

export const SelectHeader = styled.div`
  width: unset;
  ${({ theme }) => theme.media.laptop`
      width:50rem;

  `};
`;
export const CustomContentLoader = styled(ContentLoader)`
  width: 21rem;
  height: 8rem;
  margin-bottom: 0.8rem;
`;
export const CustomTitleLoader = styled.rect`
  width: 21rem;
  height: 4.4rem;
  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;
export const CustomDescrLoader = styled.rect`
  width: 21rem;
  height: 2.8rem;
  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
  y: 5rem;
`;

export const PnlToolTipWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 1.6rem;
`;

export const CustomToolTipIcon = styled(TooltipNewIcon)`
  transform: rotate(180deg);
  height: 2rem;
`;

export const BalanceEyeWrapper = styled(TransparentButton)`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 3.6rem;
  height: 3.6rem;
  padding: 0.8rem;
  background-color: ${({ theme }) => theme.colors.surface.default};
  border-radius: ${({ theme }) => theme.borderRadius.x8};

  ${({ theme }) => theme.media.laptop`
  background-color: ${
    theme.colors.surface.interactiveDefault as unknown as TemplateStringsArray
  };
  `}
`;
